import { formatContentApiRelativeUrl } from "@contember/client";
import { useGraphQlClient } from "../useGraphQlClient.js";
const useContentGraphQlClient = (projectSlug, stageSlug) => useGraphQlClient(formatContentApiRelativeUrl(projectSlug, stageSlug));
export {
  useContentGraphQlClient
};
//# sourceMappingURL=useContentGraphQlClient.js.map
